import { useContext } from "react";
import { useQuery } from "react-query";
import * as api from "../services";
import AppContext from "../appContext";

const getErrorMessage = (data) => {
  if (data && data.status === -1) return "No access";
  return "Error";
};
const isValid = (data) => {
  const status = data?.status ?? 0;
  const isArray = Array.isArray(data?.events);
  if (status > 0 && isArray) return true;
  return false;
};

const isError = (data, isLoading, isQueryError) => {
  if (isLoading && !isQueryError) return false;
  if (!isLoading && !isQueryError && isValid(data)) return false;
  return true;
};

export default function useTimeline() {
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      pauseQueries,
      sessionId,
    },
  } = useContext(AppContext);
  const {
    data: timeline,
    isLoading: isTimelineLoading,
    isError: isQueryError,
    refetch: refetchTimeline,
  } = useQuery(
    ["timeline", clientId, projectId, sessionId],
    () => api.getTimeline({ clientId, projectId, sessionId }),
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 1000 * 60 * 60 * 24,
      cacheTime: Infinity,
      enabled: clientId !== -1 && !pauseQueries,
    }
  );

  return {
    timeline,
    isTimelineLoading,
    isTimelineError: isError(timeline, isTimelineLoading, isQueryError),
    timelineError: getErrorMessage(timeline),
    refetchTimeline,
  };
}
